import { useState } from "react"
import type { ReactNode } from "react"
import { Button } from "@/components/ui/button"
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog"

export function ConfirmDialog({ trigger, title, description, confirmLabel, onConfirm, busy = false }: {
  trigger: ReactNode; title: string; description: string; confirmLabel: string; onConfirm: () => void; busy?: boolean
}) {
  const [open, setOpen] = useState(false)
  return <Dialog open={open} onOpenChange={setOpen}><DialogTrigger asChild>{trigger}</DialogTrigger><DialogContent size="sm"><DialogHeader><DialogTitle>{title}</DialogTitle><DialogDescription>{description}</DialogDescription></DialogHeader><DialogFooter><DialogClose asChild><Button variant="secondary">Cancel</Button></DialogClose><Button disabled={busy} onClick={() => { onConfirm(); setOpen(false) }}>{busy ? "Working…" : confirmLabel}</Button></DialogFooter></DialogContent></Dialog>
}
